import React, { useCallback } from "react";

import { useFormContext } from "react-hook-form";

import TimeslotRuleHeader from "./TimeslotRuleHeader";
import TimeslotRuleList from "./TimeslotRuleList";

import type { JSX } from "react";

import type { TimeslotFormValues } from "./TimeslotEdit";
import type { TimeslotRule } from "../../../api/FastAPI.types";

interface TimeslotRuleListProps {
  isLoading: boolean;
}

export default function TimeslotRuleListContainer({
  isLoading,
}: TimeslotRuleListProps): JSX.Element {
  const { watch, setValue } = useFormContext<TimeslotFormValues>();

  const rulesById = watch("rulesById");
  const ruleList = Object.values(rulesById);

  const handleRuleListChange = useCallback(
    (newRuleList: TimeslotRule[]): void => {
      setValue(
        "rulesById",
        newRuleList.reduce((acc: Record<string, TimeslotRule>, rule) => {
          acc[rule.uuid] = rule;
          return acc;
        }, {}),
      );
    },
    [setValue],
  );

  return (
    <div className="bg-muted flex size-full flex-col gap-[0.78125rem] rounded-[0.3125rem] p-[0.46875rem]">
      <div className="flex h-full flex-col overflow-auto" id="rule-container">
        <TimeslotRuleHeader />
        <TimeslotRuleList
          isLoading={isLoading}
          onRuleListChange={handleRuleListChange}
          ruleList={ruleList}
        />
      </div>
    </div>
  );
}
